<div class="container">
  <h2>Details bearbeiten</h2>
  <div class="item-form-container">

    <form [formGroup]="printerForm" (ngSubmit)="onSubmit()">

      <div class="form-field">
        <mat-form-field>
          <mat-label>Name:</mat-label>
          <input matInput type="text" formControlName="name" />
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field>
          <mat-label>Position:</mat-label>
          <input matInput type="text" formControlName="location" />
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field>
          <mat-label>IP-Adresse:</mat-label>
          <input matInput type="text" formControlName="ipAddress" />
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field>
          <mat-label>Port:</mat-label>
          <input matInput type="text" formControlName="port" />
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field>
          <mat-label>Druckkategorie auswählen</mat-label>
          <mat-select formControlName="printCategoryIdentifier">
            <mat-option *ngFor="let cat of printCategories" [value]="cat.printCategory">{{cat.printCategory}}//{{cat.tenantName}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field>
          <mat-label>Tenant auswählen</mat-label>
          <mat-select formControlName="tenantId">
            <mat-option *ngFor="let tenant of tenants" [value]="tenant.guid">{{tenant.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-checkbox formControlName="backupForOtherCategories">Backup für andere Druckkategorien</mat-checkbox>
      </div>

      <div class="form-field">
        <button mat-raised-button color="accent" type="submit" [disabled]="printerForm.invalid">Speichern</button>
      </div>

    </form>
  </div>
  <mat-dialog-actions align="end">
    <!--    <button mat-button [mat-dialog-close]="comment" cdkFocusInitial>Ok</button>-->
    <button mat-button mat-dialog-close>Abbrechen</button>
  </mat-dialog-actions>
</div>
